import { render, staticRenderFns } from "./CompanyDocumentsFolder.vue?vue&type=template&id=18e73816&"
import script from "./CompanyDocumentsFolder.vue?vue&type=script&lang=js&"
export * from "./CompanyDocumentsFolder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports